module.exports = __webpack_public_path__ + "img/salt_light.84600191.svg";